import React from "react";
import Textarea from "../Textarea";
import { Button } from "../../../assets/global/globalStyles";
import { Container, ButtonContent } from "./styles";
import { Form } from "@unform/web";

export default function FormResetPassword({
  handleSubmit,
  openModal,
  subTitle,
  formRef,
}) {
  return (
    <Container>
      <Form ref={formRef} autoComplete="off" onSubmit={handleSubmit}>
        <Textarea
          name="reason"
          label={subTitle}
          maxLength="100"
          autoFocus
        ></Textarea>
        <ButtonContent>
          <Button typeName="success" type="submit">
            Enviar
          </Button>
          <Button type="button" typeName="danger" onClick={() => openModal()}>
            Cancelar
          </Button>
        </ButtonContent>
      </Form>
    </Container>
  );
}
